import Main from '../../views/main'
import {ParentView} from '@/ladmin'
export default [
  {
    path: '/statistics',
    name: 'Statistics',
    component: Main,
    meta: {
      hideInBread: true,
    },
    children: [
      {
        path: 'vehicle',
        name: 'SearchVehicle',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/Vehicle/search'),
        meta: {
          label: '车辆查询'
        }
      },
      {
        path: 'registerUser',
        name: 'registerUser',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/User/registerUser'),
        meta: {
          label: '登记用户查询'
        }
      },
      {
        path: 'registerUserParent',
        name: 'registerUserParent',
        component: ParentView,
        redirect:{name:'registerUser'},
        meta: {
          label: '登记用户查询'
        },
        children:[
          {
            path: 'registerUserDetailBox',
            name: 'registerUserDetailBox',
            component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/User/registerUserDetailBox'),
            meta: {
              label: '登记用户详情'
            }
          },
        ]
      },
      {
        path: 'visitorUser',
        name: 'visitorUser',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/User/visitorUser'),
        meta: {
          label: '访客用户查询'
        }
      },
      {
        path: 'vehicle',
        name: 'SearchVehicleParent',
        component: ParentView,
        meta: {
          label: '车辆信息查询'
        },
        children: [
          {
            path: ':plate',
            name: 'VehicleStatisticDetails',
            component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/Vehicle/details'),
            meta: {
              label: '车辆详情',
              subText: 'params.plate',
              cacheKey: 'params.plate'
            }
          }
        ]
      },
     /* {
        path: ':plate',
        name: 'PersonStatisticDetails',
        component: () => import(/!* webpackChunkName: "statistics" *!/ '@/views/Statistics/Person/details'),
        meta: {
          label: '行人详情',
          subText: 'params.plate',
          cacheKey: 'params.plate'
        }
      },*/
      {
        path: 'person',
        name: 'SearchPersonParent',
        component: ParentView,
        meta: {
          label: '行人信息查询'
        },
        children: [
          {
            path: ':plate',
            name: 'PersonStatisticDetails',
            component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/Person/details'),
            meta: {
              label: '行人详情',
              subText: 'params.plate',
              cacheKey: 'params.plate'
            }
          }
        ]
      },
      {
        path: 'person',
        name: 'PersonPassLogListParent',
        redirect: {name: 'PersonPassLogList'},
        component: ParentView,
        meta: {
          label: '行人通行日志'
        },
        children: [
          {
            path: ':plate',
            name: 'PersonStatisticDetails',
            component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/Person/details'),
            meta: {
              label: '行人详情',
              subText: 'params.plate',
              cacheKey: 'params.plate'
            }
          },
        ]
      },
      {
        path: 'passLog',
        name: 'PassLogList',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/PassLog/list'),
        meta: {
          label: '车辆通行日志'
        }
      },
      {
        path: 'vehiclePassStatistics',
        name: 'VehiclePassStatistics',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/PassLog/vehicleStatistics'),
        meta: {
          label: '预约车辆统计'
        }
      },
      {
        path: 'personPassLog',
        name: 'PersonPassLogList',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/PassLog/personList'),
        meta: {
          label: '行人通行日志'
        }
      },
      {
        path: 'personPassStatistics',
        name: 'PersonPassStatistics',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics/PassLog/personStatistics'),
        meta: {
          label: '预约行人统计'
        }
      },
      {
        path:'tempSignList',
        name:'tempSignList',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/WX/tmpSelfSign/tempSignList'),
        meta: {
          label: '进校统计'
        }
      }
    ]
  }
]
